import get from 'lodash/get';

import { actions } from '@app/store/action/route';

function isPanelHalfOpen(routeType) {
  return routeType === 'plus';
}

function isPanelFullOpen(routeType) {
  return routeType === 'page';
}

export default function (state = {}, action) {
  const { type } = action;
  const routeType = get(action, 'route.type');
  const routeName = get(action, 'route.name');

  switch (type) {
    case actions.ROUTE_SET:
      return {
        ...state,
        ...action.route,
        nextRoute: null,
        isPanelOpen: isPanelHalfOpen(routeType) || isPanelFullOpen(routeType),
        isPanelHalfOpen: isPanelHalfOpen(routeType),
        isPanelFullOpen: isPanelFullOpen(routeType),
        isMobileTransfer: routeName === 'transfer-mobile',
      };

    case actions.ROUTE_SET_FORMSTATE:
      return {
        ...state,
        unSavedForm: action.formState,
      };

    case actions.ROUTE_SET_NEXT_ACTION:
      return {
        ...state,
        nextRoute: action.routeAction,
      };
  }

  return state;
}
